import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Gamepad, Sparkles, Mail, Phone, MessageSquare } from 'lucide-react';

const Services = () => {
  return (
    <div className="snap-y snap-mandatory overflow-y-scroll w-full min-h-screen pt-16"> {/* Added pt-16 for navbar spacing */}
      
      {/* Check These Out Section */}
      <section className="bg-gradient-to-r from-purple-100 to-blue-100 py-16 w-full snap-start">
        <h2 className="py-6 text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent text-center">
          Check These Out!
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center justify-center px-6">
          <Link to="/straygames" className="text-center bg-gradient-to-r from-blue-500 to-purple-500 px-8 py-4 rounded-lg text-xl font-bold text-white transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-purple-500/50">
            Stray Games
          </Link>
          <Link to="https://greet-app.com" className="text-center bg-gradient-to-r from-blue-500 to-purple-500 px-8 py-4 rounded-lg text-xl font-bold text-white transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-purple-500/50">
            Greet App
          </Link>
        </div>
      </section>

      {/* About Section */}
      <section className="bg-gray-100 py-20 w-full snap-start flex flex-col items-center px-6">
        <h2 className="text-5xl font-bold mb-12 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent text-center">
          Digital Solution Partner
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full max-w-6xl">
          {/* Left Side: Text & Cards */}
          <div className="space-y-8">
            {["App development", "Consultation", "System ROI analysis", "Integration Partner", "Opensource contributions"].map((title, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 border border-purple-100">
                <h3 className="text-2xl font-bold mb-4 text-purple-600">{title}</h3>
                <p className="text-lg text-gray-600">
                  {[
                    "Our in-house development team provides applied AI/ML, DevOps, DevSecOps, web app development, mobile app development, IoT services, and more.",
                    "We offer analysis and consultation on digitalizing or upgrading existing digital workflows, setting goals, and creating an implementation roadmap.",
                    "Our team will strategically help you optimize your digital expenses and manage your subscriptions through a one-stop service gateway.",
                    "We provide end-to-end liaising with multiple solution partners and manage the operation and maintenance of commissioned systems.",
                    "We are a passionate team of developers and solution engineers committed to contributing to and growing with the open-source community."
                  ][index]}
                </p>
              </div>
            ))}
          </div>
          
          {/* Right Side: Video */}
          <div className="flex justify-center items-center">
            <video autoPlay loop muted playsInline className="w-full h-auto rounded-lg shadow-lg">
              <source src="/static/videos/tec.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-6 bg-gray-900 text-gray-300 text-center">
        <p>© 2025 Stray Apps. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Services;